import { render, staticRenderFns } from "./richtext.vue?vue&type=template&id=6434f96c&scoped=true"
import script from "./richtext.vue?vue&type=script&lang=js"
export * from "./richtext.vue?vue&type=script&lang=js"
import style0 from "./richtext.vue?vue&type=style&index=0&id=6434f96c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434f96c",
  null
  
)

export default component.exports